import React from 'react';
import { useStore } from '../../context/StoreContext';

export default function ProductCard({ product }) {
  const { wishlist, addToCart, toggleWishlist, setQuickViewOpen, setQuickViewProduct } = useStore();
  const isWishlisted = wishlist.includes(product.id);
  const formatPrice = (n) => '₹' + n.toLocaleString('en-IN');

  return (
    <div className="group relative bg-white rounded-[24px] border border-slate-200 overflow-hidden hover:shadow-xl hover:shadow-slate-200/60 transition">
      <div className="relative aspect-[4/5] bg-slate-100 overflow-hidden">
        <img src={product.img} className="w-full h-full object-cover group-hover:scale-105 transition duration-700" alt={product.name} />
        <span className="absolute top-3 left-3 px-2 py-1 rounded-full bg-white/90 backdrop-blur text-[11px] font-bold text-rose-600">
          {product.off}% OFF
        </span>
        <button 
          onClick={() => toggleWishlist(product.id)}
          className="absolute top-3 right-3 w-9 h-9 grid place-items-center rounded-full bg-white/90 backdrop-blur hover:bg-white"
        >
          <i className={`ri-heart-3-${isWishlisted ? 'fill text-rose-600' : 'line'} text-[18px]`}></i>
        </button>
        <button 
          onClick={() => {
            setQuickViewProduct(product);
            setQuickViewOpen(true);
          }}
          className="absolute bottom-3 left-1/2 -translate-x-1/2 translate-y-3 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition px-4 h-10 rounded-full bg-slate-900 text-white text-xs font-semibold shadow-lg"
        >
          Quick View
        </button>
      </div>
      <div className="p-3">
        <p className="text-[11px] font-bold tracking-wide uppercase text-slate-500">{product.brand}</p>
        <h4 className="text-[14px] font-semibold leading-snug mt-0.5 line-clamp-1">{product.name}</h4>
        <div className="flex items-center gap-1 mt-1">
          <div className="flex text-amber-500 text-[12px]"><i className="ri-star-s-fill"></i></div>
          <span className="text-[11px] text-slate-500">{product.rating} • {product.reviews}</span>
        </div>
        <div className="mt-2 flex items-baseline gap-2">
          <span className="font-bold">{formatPrice(product.price)}</span>
          <span className="text-xs text-slate-400 line-through">{formatPrice(product.mrp)}</span>
        </div>
      </div>
      <button 
        onClick={() => addToCart(product)}
        className="absolute bottom-3 right-3 w-9 h-9 grid place-items-center rounded-xl bg-indigo-600 text-white hover:bg-indigo-700 shadow-lg shadow-indigo-600/25"
      >
        <i className="ri-add-line text-xl"></i>
      </button>
    </div>
  );
}